const digitalPayErrorDisplayComponentDefinition = {
    template: require('./digital-pay-error-display.component.html').trim(),
    bindings: {
        errorMessage: '<',
        errorList: '<',
        isOnTop: '<',
        customErrorClass: '@?',
        hideErrorList: '<?',
        title: '<?',
    },
};

module.exports = {
    digitalPayErrorDisplayComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/wallet/error/digital-pay-error-display.component.js